import { ScreenAdditionalFilter } from '../typings/domain';
import { FilterPartialExpression } from '../typings/filter';
import { PeriodFilterValue } from '../typings/filters';

export const GRID_NAVIGATION_GO_TO_FILTER = 'GRID_NAVIGATION_GO_TO_FILTER';
export type GRID_NAVIGATION_GO_TO_FILTER = typeof GRID_NAVIGATION_GO_TO_FILTER;

export interface GridNavigationGoToFilterAction {
    type: GRID_NAVIGATION_GO_TO_FILTER;
    expressions: FilterPartialExpression[];
}

export function navToFilter(expressions: FilterPartialExpression[]): GridNavigationGoToFilterAction {
    return {
        type: GRID_NAVIGATION_GO_TO_FILTER,
        expressions
    };
}

export const GRID_NAVIGATION_GO_TO_ADDITIONAL_FILTER = 'GRID_NAVIGATION_GO_TO_ADDITIONAL_FILTER';
export type GRID_NAVIGATION_GO_TO_ADDITIONAL_FILTER = typeof GRID_NAVIGATION_GO_TO_ADDITIONAL_FILTER;

export interface GridNavigationGoToAdditionalFilterAction {
    type: GRID_NAVIGATION_GO_TO_ADDITIONAL_FILTER;
    additionalFilter: ScreenAdditionalFilter;
}

export function navToAdditionalFilter(
    additionalFilter: ScreenAdditionalFilter
): GridNavigationGoToAdditionalFilterAction {
    return {
        type: GRID_NAVIGATION_GO_TO_ADDITIONAL_FILTER,
        additionalFilter
    };
}

export const GRID_NAVIGATION_GO_TO_STAT_PERIOD_URL = 'GRID_NAVIGATION_GO_TO_STAT_PERIOD_URL';
export type GRID_NAVIGATION_GO_TO_STAT_PERIOD_URL = typeof GRID_NAVIGATION_GO_TO_STAT_PERIOD_URL;

export interface GridNavigationGoToStatPeriodUrlAction {
    type: GRID_NAVIGATION_GO_TO_STAT_PERIOD_URL;
    period: PeriodFilterValue;
}

export function navToStatPeriodUrl(period: PeriodFilterValue): GridNavigationGoToStatPeriodUrlAction {
    return {
        type: GRID_NAVIGATION_GO_TO_STAT_PERIOD_URL,
        period
    };
}

export type GridNavigationAction =
    | GridNavigationGoToFilterAction
    | GridNavigationGoToAdditionalFilterAction
    | GridNavigationGoToStatPeriodUrlAction;
